
export enum AppEnities {
  HOME = "Home",
  SETTINGS = "Settings",
  USER = "Manage Users",
  PERMISSION = "Permission",
  ROLE = "Manage Roles & Access Rights",
  CONTROL_PARAMS = "Company Parameters",
  ENQUIRIES = "Manage Enquiries",
  DISCIPLINE = "Manage Disciplines",
  ORGANISATIONS = "Manage Organisations",
  HELP = "Manage Help Information",
  LICENSE = "License Agreement",
  EVALUATION = "Manage Evaluations",
  PLACEMENT_REVIEW = "Manage Placement Reviews",
  MY_REVIEW = "My Reviews",
  RESEARCH_DATA_EXPORT = "Research Data Extract"
};

export enum FormModes {
  NOTSET = 'Not Set',
  NEW = 'New',
  EDIT = 'Edit',
  VIEW = 'View',
  COPY = 'Copy'
};

export enum OrderDirection {
  UP = 'up',
  DOWN = 'down'
}

export const EMAIL_REGEX = '/^[a-zA-Z0-9]+[a-zA-Z0-9._+-]+@[a-zA-Z0-9-_]+\.[a-zA-Z.]{2,}$/';
export const PHONE_REGEX = "^[0-9()+ ]+$";
export const PHONE_REGEX_V2 = "^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$";

export enum CasiCloseOptions {
  Saved = 'saved',
  Cancelled = 'cancelled',
  Ok = 'ok',
  Closed = 'closed',
  Navigate = 'navigate',
  Complete = 'complete'
};

export enum MessageStates {
  Before = 'before',
  InProgress = 'inprogress',
  After = 'after',
  Error = 'error'
};

export enum ResetStages {
  None = 'NONE',
  SMSReceived = 'SMS_RECEIVED',
  AccessTokenReceived = 'ACCESS_TOKEN_RECEIVED',
  Completed = 'COMPLETED'
};

export enum ExpiryStages {
  Expired = 'EXPIRED',
  Warning = 'WARNING',
  Imminent = 'IMMINENT',
  Safe = 'SAFE'
};

export const cookieHeaderName = 'X-CSRF-TOKEN';
// export const cookieHeaderName = 'XSRF-TOKEN';
export const csrfTokenName = 'X-CSRF-TOKEN';

export enum DrawItemNames {
  MyWork = 'My work',
  CurrentBacklog = 'Current/backlog',
  IceBox = 'Icebox',
  Done = 'Done',
  Blocked = 'Blocked',
  Epics = 'Epics',
  Labels = 'Labels',
  ProjectHistory = 'Project history'
}

export enum CasiEventName {
  notSet = 'notset',
  add = 'add',
  close = 'close'
}

export enum StoryTypes {
  Feature = 'feature',
  Bug = 'bug',
  Chore = 'chore',
  Release = 'release'
};

export enum StoryStates {
  Accepted = 'Accepted',
  Delivered = 'Delivered',
  Finished = 'Finished',
  Rejected = 'Rejected',
  Started = 'Started',
  Unscheduled = 'Unscheduled',
  Unstarted = 'Unstarted',
  Deleted = 'Deleted'
};

export enum StoryPriorities {
  P0 = 'PO - Critical',
  P1 = 'P1 - High',
  P2 = 'P2 - Medium',
  P3 = 'P3 - Low',
  None = 'None'
};

export enum StoryPoints {
  '0 Point' = '0 Point',
  '1 Point' = '1 Point',
  '2 Point' = '2 Point',
  '3 Point' = '3 Point'
};

export enum StoryLabels {
  One = 1,
  Two = 2,
  Three = 3,
  Four = 4,
  Five = 5,
  Improvement = 'improvement',
  Mvp = 'mvp',
  NaaImplementation = 'naa implementation'
};

export enum CommentSortOptions {
  oldestToNewest = "Oldest to newest",
  newestToOldest = "Newest to oldest"
};

export enum UserStoryReviewTypes {
  TestQA = "Test (QA)",
  Design = "Design",
  Code = "Code",
  Security = "Security"
};

export enum UserStoryReviewStatus {
  Unstarted = "Unstarted",
  InReview = "In review",
  Pass = "Pass",
  Revise = "Revise"
};

export const blastKeys = {
  USER_STORY_UPDATED: "user-story-updated",
  PROJECT_UPDATED: 'project-updated',
  USER_UPDATED: 'user-updated',
  SUMMARY_UPDATED: 'summary-updated'
};

export enum ItemModes {
  CREATION = 'creation',
  UPDATE = 'update',
  NOT_SET = 'not_set'
};

export const refreshTokenEndpoint = '___refreshtoken';

export interface IDocType {
  value: string;
  text: string;
};
export const docTypes: Array<IDocType> = [
  <IDocType>{ value: 'terms', text: 'Customer Licence Agreement' },
  <IDocType>{ value: 'disclaimer', text: 'Terms of Use' },
  <IDocType>{ value: 'privacy', text: 'Privacy Policy' }
];

export const captchaLength = 6;

export const captchaExpirySeconds = 120000;
export const captchaExpiryMinutes = !!captchaExpirySeconds ? captchaExpirySeconds / 60000 : 2;


export const RESPONSE_TYPES: string[] = [
  'Text',
  'Numeric',
  'Select One',
  'Select Many'
];

export const NOT_SET = 'not set';
